import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {BlockComp} from "../../core/components/blockComp/blockComp";
import ActiveItem from "../../core/components/blockComp/activeItem";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {DefinitionType, PropsObjectType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import {BUILDINGTYPE, EVALUATIONPHASE, EVALUATIONTYPE, Project} from "../domain/project/projectDomain";
import StyledSelect from "../../core/components/fields/styledSelect";
import StyledDatePicker from "../../core/components/fields/styledDatePicker";
import {IsRequired} from "../../core/form/rules";

@observer
class ProjectForm extends React.Component<FormProps<Project, Project>> {

  render() {
    let {dataObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(definition.formName);
    let {
      name, description, address, cadastralParcelNumber, cadastralParcelArea, documentationCreator,
      documentationCreated, documentationLevel, evaluator, projectCreated,
      area, countOfHousingUnits, countOfPeople, buildingType, schoolLevel,
      cellarCompartment, garage, zpkm, documentationVersion, projectEvaluationFinished,
      estimatedCosts, anticipatedCommissioning, evaluationPhase, evaluationType, certified_person
    } = fields;

    let schoolTypeValidation = this.isSchoolTypeValidationNeeded(buildingType.props) ?
      <Validate field={schoolLevel} value={schoolLevel.props.value}/> : <noscript/>;

    let openContent = (
      <div>
        <div className="row">
          <MdTextField {...name.props} />
          <Validate field={name} value={name.props.value}/>
        </div>

        <div className="row">
          <MdTextField {...description.props}/>
        </div>
        <div className="row">
          <div className="col-xs-5">
            <MdTextField {...address.props} />
            <Validate field={address} value={address.props.value}/>
          </div>
          <div className="col-xs-4">
            <MdTextField {...cadastralParcelArea.props} />
            {/*<Validate field={cadastralParcelArea} value={cadastralParcelArea.props.value}/>*/}
          </div>
          <div className="col-xs-3">
            <MdTextField {...cadastralParcelNumber.props} />
            {/*<Validate field={cadastralParcelNumber} value={cadastralParcelNumber.props.value}/>*/}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-2">
            <MdTextField {...documentationCreator.props} />
            {/*<Validate field={documentationCreator} value={documentationCreator.props.value}/>*/}
          </div>
          <div className="col-xs-2">
            <StyledDatePicker {...documentationCreated.props} />
            {/*<Validate field={documentationCreated} value={documentationCreated.props.value}/>*/}
          </div>
          <div className="col-xs-3">
            <StyledSelect {...documentationLevel.props} />
            {/*<Validate field={documentationLevel} value={documentationLevel.props.value}/>*/}
          </div>
          <div className="col-xs-2">
            <StyledSelect {...buildingType.props} onChange={this.onChangeBuildingType}/>
            <Validate field={buildingType} value={buildingType.props.value}/>
          </div>
          <div className="col-xs-2">
            <StyledSelect {...schoolLevel.props} disabled={this.isSchoolTypeFieldDisabled(buildingType.props)}/>
            {schoolTypeValidation}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-3">
            <MdTextField {...evaluator.props} />
            {/*<Validate field={evaluator} value={evaluator.props.value}/>*/}
          </div>
          <div className="col-xs-3">
            <MdTextField {...certified_person.props} />
            {/*<Validate field={certified_person} value={certified_person.props.value}/>*/}
          </div>
          <div className="col-xs-6">
            <StyledDatePicker {...projectCreated.props} />
            {/*<Validate field={projectCreated} value={projectCreated.props.value}/>*/}
          </div>
        </div>
        {/*<div className="row">*/}
        {/*  <div className="col-xs-4">*/}
        {/*    <MdTextField {...area.props} />*/}
        {/*    <Validate field={area} value={area.props.value}/>*/}
        {/*  </div>*/}
        {/*  <div className="col-xs-4">*/}
        {/*    <MdTextField {...countOfHousingUnits.props} />*/}
        {/*    <Validate field={countOfHousingUnits} value={countOfHousingUnits.props.value}/>*/}
        {/*  </div>*/}
        {/*  <div className="col-xs-4">*/}
        {/*    <MdTextField {...countOfPeople.props} />*/}
        {/*    <Validate field={countOfPeople} value={countOfPeople.props.value}/>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="row">
          <div className="col-xs-1">
            <MdTextField {...documentationVersion.props} />
            {/*<Validate field={documentationVersion} value={documentationVersion.props.value}/>*/}
          </div>
          <div className="col-xs-3">
            <StyledDatePicker {...projectEvaluationFinished.props} />
            {/*<Validate field={projectEvaluationFinished} value={projectEvaluationFinished.props.value}/>*/}
          </div>
          <div className="col-xs-4">
            <MdTextField {...estimatedCosts.props} />
            {/*<Validate field={estimatedCosts} value={estimatedCosts.props.value}/>*/}
          </div>
          <div className="col-xs-4">
            <StyledDatePicker {...anticipatedCommissioning.props} />
            {/*<Validate field={anticipatedCommissioning} value={anticipatedCommissioning.props.value}/>*/}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <StyledSelect {...evaluationPhase.props}/>
            {/*<Validate field={evaluationPhase} value={evaluationPhase.props.value}/>*/}
          </div>
          <div className="col-xs-6">
            <StyledSelect {...evaluationType.props}/>
            <Validate field={evaluationType} value={evaluationType.props.value}/>
          </div>
        </div>
        {/*<div className="row">*/}
        {/*  <div className="col-xs-4">*/}
        {/*    /!*<span style={{color: "red"}}>*/}
        {/*      {loc.i18n`Cellar Compartment Checkbox Title`}*/}
        {/*      <MdCheckbox  mdField={cellarCompartment.props.value}   />*/}
        {/*    </span>*/}
        {/*    <Validate field={cellarCompartment} value={cellarCompartment.props.value}/>*!/*/}
        {/*    <MdCheckbox {...cellarCompartment.props}/>*/}
        {/*  </div>*/}
        {/*  <div className="col-xs-4">*/}
        {/*    <MdCheckbox {...garage.props}/>*/}
        {/*  </div>*/}
        {/*  <div className="col-xs-4">*/}
        {/*    <MdCheckbox {...zpkm.props}/>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    );

    return (
      <BlockComp noPadding>
        <ActiveItem openContent={openContent}
                    closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />}
                    validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }

  private isSchoolTypeValidationNeeded = (props : PropsObjectType) : boolean => {
    return (props.value && props.value.value == BUILDINGTYPE.EDU);
  };

  private isSchoolTypeFieldDisabled = (props: PropsObjectType): boolean => {
    return !(props.value && props.value.value === BUILDINGTYPE.EDU);
  };



  private onChangeBuildingType = (value: any): void => {
    let {dataObject} = this.props;
    let form = dataObject.getForm(definition.formName);
    form.getField("buildingType").props.onChange(value);
    if (value === null || value.value !== BUILDINGTYPE.EDU) {
      dataObject.schoolLevel = null;
      form.updateFieldsPropValue(dataObject, "schoolLevel");
    }
  }
}


const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<Project>) => (
  <div style={{width: '100%'}}>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.name.textLabel} value={dataObject.name}/>
      <ClosedFormField label={fields.description.textLabel} value={dataObject.description}/>
      <ClosedFormField label={fields.address.textLabel} value={dataObject.address}/>
      <ClosedFormField label={fields.cadastralParcelNumber.textLabel} value={dataObject.cadastralParcelNumber}/>
      <ClosedFormField label={fields.documentationCreator.textLabel} value={dataObject.documentationCreator}/>
      <ClosedFormField label={fields.documentationLevel.textLabel} value={dataObject.documentationLevel}/>
      <ClosedFormField label={fields.evaluator.textLabel} value={dataObject.evaluator}/>
      <ClosedFormField label={fields.certified_person.textLabel} value={dataObject.certified_person}/>
      <ClosedFormField label={fields.projectCreated.textLabel} value={dataObject.projectCreated}/>
      {/*<ClosedFormField label={fields.area.textLabel} value={dataObject.area}/>*/}
      {/*<ClosedFormField label={fields.countOfHousingUnits.textLabel} value={dataObject.countOfHousingUnits}/>*/}
      {/*<ClosedFormField label={fields.countOfPeople.textLabel} value={dataObject.countOfPeople}/>*/}
      <ClosedFormField label={fields.buildingType.textLabel} value={dataObject.buildingType}/>
      <ClosedFormField label={fields.schoolLevel.textLabel} value={dataObject.schoolLevel}/>
      {/*<ClosedFormField label={fields.cellarCompartment.textLabel} value={ (dataObject.cellarCompartment) ? 'Ano' : 'Ne' }/>*/}
      {/*<ClosedFormField label={fields.garage.textLabel} value={ (dataObject.garage) ? 'Ano' : 'Ne' }/>*/}
      {/*<ClosedFormField label={fields.zpkm.textLabel} value={ (dataObject.zpkm) ? 'Ano' : 'Ne' }/>*/}
      <ClosedFormField label={fields.cadastralParcelArea.textLabel} value={dataObject.cadastralParcelArea}/>
      <ClosedFormField label={fields.documentationVersion.textLabel} value={dataObject.documentationVersion}/>
      <ClosedFormField label={fields.projectEvaluationFinished.textLabel} value={dataObject.projectEvaluationFinished}/>
      <ClosedFormField label={fields.estimatedCosts.textLabel} value={dataObject.estimatedCosts}/>
      <ClosedFormField label={fields.anticipatedCommissioning.textLabel} value={dataObject.anticipatedCommissioning}/>
      <ClosedFormField label={fields.evaluationPhase.textLabel} value={dataObject.evaluationPhase}/>
      <ClosedFormField label={fields.evaluationType.textLabel} value={dataObject.evaluationType}/>
    </ClosedFormBlock>
  </div>
);


const definition: DefinitionType = {
  formName: 'SbToolProjectForm',
  fields: [
    {name: 'name',validators: ['IsRequired']},
    {name: 'address',validators: ['IsRequired']},
    {name: 'description'},
    {name: 'cadastralParcelNumber'},
    {name: 'cadastralParcelArea'},
    {name: 'documentationCreator'},
    {name: 'documentationCreated'},
    {name: 'documentationLevel'},
    {name: 'evaluator'},
    {name: 'certified_person'},
    {name: 'projectCreated'},
    // {name: 'area',validators: ['IsRequired', 'IsNumber']},
    // {name: 'countOfHousingUnits',validators: ['IsRequired', 'IsNumber']},
    // {name: 'countOfPeople',validators: ['IsRequired', 'IsNumber']},
    {name: 'buildingType',validators: ['IsRequired']},
    {name: 'schoolLevel',validators: ['IsRequired']},
    // {name : 'cellarCompartment',validators: ['IsRequired']},
    // {name : 'garage',validators: ['IsRequired']},
    // {name : 'zpkm',validators: ['IsRequired']},
    {name: 'documentationVersion'},
    {name: 'projectEvaluationFinished'},
    {name: 'estimatedCosts'},
    {name : 'anticipatedCommissioning'},
    {name : 'evaluationPhase'},
    {name : 'evaluationType',validators: ['IsRequired']}
  ]
};

export default createForm(definition, ClosedContent)(ProjectForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectForm.tsx